import { makeCSSVar, readCSSVar } from 'lib/theme/themeUtils'

export const themeLayoutCSSVariables: App.Design.Layout<App.Design.CSSVar> = {
  topScrollOffset: makeCSSVar('app', 'top', 'scroll', 'offset'),
  headerFloatingOffset: makeCSSVar('app', 'header', 'floating', 'offset'),
  headerRelativeOffset: makeCSSVar('app', 'header', 'relative', 'offset'),
  footerFloatingOffset: makeCSSVar('app', 'footer', 'floating', 'offset'),
  footerRelativeOffset: makeCSSVar('app', 'footer', 'relative', 'offset'),
}

const themeLayout: App.Design.Layout<App.Design.CSSVarValue> = {
  topScrollOffset: readCSSVar(themeLayoutCSSVariables.topScrollOffset, '0px'),
  headerFloatingOffset: readCSSVar(themeLayoutCSSVariables.headerFloatingOffset, '0px'),
  headerRelativeOffset: readCSSVar(themeLayoutCSSVariables.headerRelativeOffset, '0px'),
  footerFloatingOffset: readCSSVar(themeLayoutCSSVariables.footerFloatingOffset, '0px'),
  footerRelativeOffset: readCSSVar(themeLayoutCSSVariables.footerRelativeOffset, '0px'),
}

export default themeLayout
